var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import TopFundsTableDesk from "./TopFundsTableDesk";
import TopFundsViewAllFunctionality from "./FundsViewAll/TopFundsViewAllFunctionality";
import TopFundsTableMobile from "./FundsViewAll/TopFundsTableMobile";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { useLocation, useParams } from "react-router-dom";
import di from "@mainDi/features/mutualFund/servicelocator";
import { MutualFundsSchemesConfig } from "@frameworks/web/components/features/Markets/MutualFunds/MutualFundsConfig";
import { EMFFilterType, } from "@domains/features/Markets/MutualFunds/entities/MutualFundsSchemesEntity";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/shared-library/components/ErrorNotification";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import _ from "underscore";
import { useCustomSelector } from "@frameworks/shared-library/components/customHooks/customUseSector";
import bookMarkDi from "@mainDi/features/bookmarks/servicelocator";
import "../../stylesheets/components/TopPerformingFunds/TopPerformingFunds.scss";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTabs.scss";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ESortOrder, } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import { removeEmptyKeyValuesPairs } from "@domains/utils/validation";
import GenericScrollToTopButton from "@frameworks/shared-library/components/GenericScrollToTopButton/GenericScrollToTopButton";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
export var defaultMutualFundsFilter = {
    amcName: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    category: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    rating: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    riskValue: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    schemeType: undefined,
    "1yCagr": undefined,
    "3yCagr": undefined,
    "5yCagr": undefined,
    expenseRatio: undefined,
    aumSize: undefined,
};
export var initialMFFilters = {
    categoryCode: [],
    catCode: [],
    riskValue: [],
    rating: [],
    schType: [],
    schPlan: [],
    year1: null,
    year3: null,
    year5: null,
    amcName: [],
    subCatCode: [],
    benchmark: [],
    expenseRatio: undefined,
    fundSize: undefined,
    isFeatured: "",
    isNew: "",
    pageNo: 0,
    pageSize: 10,
    schemeCode: [],
    sortColumn: "Year3",
    sortOrder: ESortOrder.DESCENDING,
    rank: ["1"],
};
var TopPerformingFundsTabs = function (props) {
    // *******************************************
    // *           useStates                     *
    // *******************************************
    var _a, _b, _c, _d;
    var _e = __read(useState((props === null || props === void 0 ? void 0 : props.tabList) && props.tabList.length ? (_a = props === null || props === void 0 ? void 0 : props.tabList[1]) === null || _a === void 0 ? void 0 : _a.eventKey : "" // Pre-selecting 2rd value from Tablist - Featured Funds
    ), 2), tab = _e[0], setTab = _e[1];
    var _f = __read(React.useState(), 2), configRequestPayload = _f[0], setConfigRequestPayload = _f[1];
    var _g = __read(React.useState(), 2), requestPayload = _g[0], setRequestPayload = _g[1];
    var _h = __read(useState(false), 2), showToast = _h[0], setShowToast = _h[1];
    var _j = __read(useState({
        isError: false,
        msg: "",
    }), 2), toastDetails = _j[0], setToastDetails = _j[1];
    var _k = __read(useState(0), 2), page = _k[0], setPage = _k[1]; //TODO: Need to check this if main filter state can be used in place of this
    var _l = __read(useState(), 2), tableData = _l[0], setTableData = _l[1];
    var _m = __read(useState(), 2), bookMarkData = _m[0], setBookMarkData = _m[1];
    var _o = __read(React.useState(defaultMutualFundsFilter), 2), mutualFundDisplayFilters = _o[0], setMutualFundDisplayFilters = _o[1];
    var _p = __read(React.useState(JSON.parse(JSON.stringify(initialMFFilters))), 2), masterMutualFundFilterSortValues = _p[0], setMasterMutualFundFilterSortValues = _p[1];
    var _q = __read(React.useState(JSON.parse(JSON.stringify(initialMFFilters))), 2), localMutualFundFilterSortValues = _q[0], setLocalMutualFundFilterSortValues = _q[1];
    var _r = __read(React.useState(false), 2), isShowMainFilterSortPopup = _r[0], setIsShowMainFilterSortPopup = _r[1];
    var _s = __read(React.useState({}), 2), selectedFiltersData = _s[0], setSelectedFiltersData = _s[1];
    var _t = __read(React.useState(false), 2), isShowFilterLoader = _t[0], setIsShowFilterLoader = _t[1];
    var _u = __read(React.useState({}), 2), filterFieldsErrors = _u[0], setFilterFieldsErrors = _u[1];
    // *******************************************
    // *          custom hooks                  *
    // *******************************************
    var device = DeviceContext();
    var location = useLocation();
    var subSection = useParams().subSection;
    var requestPayloadState = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.requestPayloadState;
    var paramsData = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.paramsData;
    }, _.isEqual);
    var mutualFundsLoader = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.mutualFundsLoader;
    });
    var totalPages = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.totalPages;
    }, _.isEqual);
    var mutualFundsSchemeList = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.mutualFundsSchemeList;
    }, _.isEqual);
    var searchSortedDataData = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.updateData;
    }, _.isEqual);
    var errorData = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.errorData;
    }, _.isEqual);
    var messageData = useCustomSelector(function (state) { return state.markets.MutualFunds.mutualFundsSchemes.message; }, _.isEqual);
    // *******************************************
    // *           useRefs                     *
    // *******************************************
    var prevValuesRef = React.useRef(JSON.parse(JSON.stringify(initialMFFilters)));
    var isFirstRender = React.useRef(true);
    // *******************************************
    // *           useMemos                     *
    // *******************************************
    var riskValueMap = useMemo(function () {
        var _a, _b;
        return new Map((_b = (_a = mutualFundDisplayFilters === null || mutualFundDisplayFilters === void 0 ? void 0 : mutualFundDisplayFilters.riskValue) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.map(function (item) { return [
            item === null || item === void 0 ? void 0 : item.value,
            item === null || item === void 0 ? void 0 : item.searchKey,
        ]; }));
    }, [(_c = mutualFundDisplayFilters === null || mutualFundDisplayFilters === void 0 ? void 0 : mutualFundDisplayFilters.riskValue) === null || _c === void 0 ? void 0 : _c.list]);
    var getMutualFundsFilter = useMemo(function (filterParameters) {
        if (filterParameters === void 0) { filterParameters = localMutualFundFilterSortValues; }
        return function (filterValues) {
            if (filterValues === void 0) { filterValues = filterParameters; }
            if (_.isEqual(filterValues, prevValuesRef.current && !isFirstRender.current)) {
                return;
            }
            // prevValuesRef.current = mutualFundFilterSortValues;
            setIsShowFilterLoader(true);
            di.mutualFunds
                .getFilters(__assign({}, filterValues))
                .then(function (data) {
                if (!!data) {
                    setMutualFundDisplayFilters(data);
                    // Update prevValuesRef after successful API call
                    prevValuesRef.current = filterValues;
                }
                setIsShowFilterLoader(false);
            })
                .catch(function (err) {
                setIsShowFilterLoader(false);
                console.log(err);
            });
            if (isFirstRender.current) {
                isFirstRender.current = false;
            }
        };
    }, [masterMutualFundFilterSortValues, localMutualFundFilterSortValues]);
    // *******************************************
    // *           API functions                     *
    // *******************************************
    var updateRequestPayload = function (requestPayload) {
        di.mutualFunds.updateParams(requestPayload);
    };
    var getMutualFundsSchems = function (requestPayload) {
        setRequestPayload(requestPayload);
        // requestPayload.viewAll = props.viewAll;
        if (!props.viewAll) {
            requestPayload.pageSize = 3;
        }
        var cleanedFilterObj = removeEmptyKeyValuesPairs(requestPayload);
        if ((cleanedFilterObj === null || cleanedFilterObj === void 0 ? void 0 : cleanedFilterObj.sortColumn) === "NameDSC") {
            cleanedFilterObj.sortColumn = "Name";
        }
        var isSearchOrFilterApplied = handleCheckIfSearchOrFilterApplied(cleanedFilterObj);
        if (isSearchOrFilterApplied) {
            delete cleanedFilterObj["rank"];
        }
        di.mutualFunds.getMutalFundsSchemes(__assign({}, cleanedFilterObj));
    };
    var getBookMark = function () {
        bookMarkDi.bookmarks
            .fetchBookmarks({
            pageSize: 100,
            pageNo: 0,
        })
            .then(function (data) {
            var _a;
            setBookMarkData((_a = data === null || data === void 0 ? void 0 : data.mutualFundSummary) === null || _a === void 0 ? void 0 : _a.map(function (x) { return x.schemeCode; }));
        });
    };
    var savebookMark = function (schemeCode) {
        bookMarkDi.bookmarks
            .saveBookmarks({
            schemeCode: schemeCode,
        })
            .then(function (z) {
            setBookMarkData(function (book) { return __spreadArray(__spreadArray([], __read((book || [])), false), __read((schemeCode || [])), false); });
            setShowToast(true);
            setToastDetails({
                isError: false,
                msg: "Bookmark Saved!",
            });
        })
            .catch(function (error) {
            setShowToast(true);
            setToastDetails({
                isError: true,
                msg: "Failed to save Bookmark!",
            });
        });
    };
    var deleteBookMark = function (schemeCode) {
        bookMarkDi.bookmarks
            .deleteBookmarks({
            schemeCode: schemeCode,
        })
            .then(function (z) {
            setBookMarkData(function (book) {
                var booklist = JSON.parse(JSON.stringify(book));
                schemeCode.map(function (x) {
                    var index = book.findIndex(function (z) { return z === x; });
                    booklist.splice(index, 1);
                });
                return booklist;
            });
            setShowToast(true);
            setToastDetails({
                isError: false,
                msg: "Bookmark removed Succesfully!",
            });
        })
            .catch(function (error) {
            setShowToast(true);
            setToastDetails({
                isError: true,
                msg: "Failed to remove Bookmark!",
            });
        });
    };
    // *******************************************
    // *           Handler functions                     *
    // *******************************************
    var handleUpdateMasterSortFilterValuesState = function (data) {
        setMasterMutualFundFilterSortValues(data);
    };
    var handleApplyFilter = function (data) {
        var currentActiveTab = handleFindCurrentActiveTabFromList();
        var filterValues = data ? data : __assign({}, localMutualFundFilterSortValues);
        filterValues.catCode =
            !!currentActiveTab && (currentActiveTab === null || currentActiveTab === void 0 ? void 0 : currentActiveTab.eventCode) !== "0"
                ? [currentActiveTab.eventCode]
                : [];
        // Page number needs to be reset to 0 when applying filters as new data is needed
        setPage(0);
        filterValues.pageNo = 0;
        var validatedFilterData = handleValidateFilterFields(filterValues);
        if (validatedFilterData.validationsPassed) {
            handleUpdateMasterSortFilterValuesState(validatedFilterData.localFilterData);
            setLocalMutualFundFilterSortValues(validatedFilterData.localFilterData);
            var getRiskLabel = {
                risk: validatedFilterData.localFilterData.riskValue.reduce(function (acc, valueItem) {
                    var searchKey = riskValueMap.get(valueItem);
                    if (searchKey)
                        acc.push(searchKey);
                    return acc;
                }, []),
            };
            var payloadForFilters = __assign(__assign({}, validatedFilterData.localFilterData), getRiskLabel);
            // riskValue not needed in payload but is needed in checkbox configurations
            payloadForFilters.riskValue = null;
            getMutualFundsSchems(payloadForFilters);
            setIsShowMainFilterSortPopup(false);
        }
    };
    var handleValidateFilterFields = function (filterData) {
        var localFilterData = __assign({}, filterData);
        var filterTabKeys = Object.keys(mutualFundDisplayFilters);
        var localFilterErrorObject = __assign({}, filterFieldsErrors);
        filterTabKeys.forEach(function (key) {
            var filterTabObj = mutualFundDisplayFilters[key];
            var localFilterValues = localFilterData[filterTabObj.value];
            if (filterTabObj.shouldValidate && !!localFilterValues) {
                var localStaticFilters = localFilterValues;
                if ((!!localStaticFilters.operator && !localStaticFilters.value) ||
                    (!!localStaticFilters.value && !localStaticFilters.operator)) {
                    if (!localStaticFilters.value) {
                        localFilterErrorObject[filterTabObj.value] = {
                            inputError: "This field is required",
                        };
                    }
                    if (!localStaticFilters.operator) {
                        localFilterErrorObject[filterTabObj.value] = {
                            selectError: "This field is required",
                        };
                    }
                }
                else if (!localStaticFilters.value || !localStaticFilters.operator) {
                    delete localFilterErrorObject[filterTabObj.value];
                    delete localFilterData[filterTabObj.value];
                }
                else {
                    delete localFilterErrorObject[filterTabObj.value];
                }
            }
        });
        setFilterFieldsErrors(localFilterErrorObject);
        return {
            validationsPassed: !Object.keys(localFilterErrorObject).length,
            localFilterData: localFilterData,
        };
    };
    var handleCancelApplyingFilter = function (masterFilterSortData) {
        if (masterFilterSortData === void 0) { masterFilterSortData = masterMutualFundFilterSortValues; }
        setIsShowMainFilterSortPopup(false);
        var localMasterFilterSortValues = removeEmptyKeyValuesPairs(masterFilterSortData);
        var localSelectedFiltersData = {};
        Object.keys(localMasterFilterSortValues).forEach(function (filterKey) {
            // localSelectedFiltersData[filterKey]={}
            if (Array.isArray(localMasterFilterSortValues[filterKey])) {
                localMasterFilterSortValues[filterKey].forEach(function (filterVal) {
                    var _a;
                    localSelectedFiltersData[filterKey] = __assign(__assign({}, localSelectedFiltersData[filterKey]), (_a = {}, _a[filterVal] = {
                        filterValue: filterVal,
                    }, _a));
                    // = {[filterVal]:{}}
                });
            }
        });
        handleUpdateSelectedFiltersState(localSelectedFiltersData);
        setLocalMutualFundFilterSortValues(__assign({}, JSON.parse(JSON.stringify(masterFilterSortData))));
    };
    var handleClearAllFilters = function () {
        var currentActiveTab = handleFindCurrentActiveTabFromList();
        var updatedData = __assign(__assign(__assign({}, JSON.parse(JSON.stringify(initialMFFilters))), { categoryCode: [props.categoryCode] }), (!!currentActiveTab &&
            (currentActiveTab === null || currentActiveTab === void 0 ? void 0 : currentActiveTab.eventCode) !== "0" && {
            catCode: [currentActiveTab.eventCode],
        }));
        getMutualFundsSchems(updatedData);
        resetFilterSortValuesStatesToInitial(updatedData);
    };
    var handleClearSpecificFilter = function (filterKeyName) {
        var _a;
        var filterValues = __assign(__assign({}, masterMutualFundFilterSortValues), (_a = {}, _a[filterKeyName] = initialMFFilters[filterKeyName], _a));
        var localSelectedData = __assign({}, selectedFiltersData);
        delete localSelectedData[filterKeyName];
        onFilterSelectionCallback(filterValues);
        handleUpdateSelectedFiltersState(localSelectedData);
        handleApplyFilter(filterValues);
    };
    var handleUpdateSelectedFiltersState = function (data) {
        setSelectedFiltersData(data);
    };
    var handleFindCurrentActiveTabFromList = function () {
        var _a;
        return (_a = props === null || props === void 0 ? void 0 : props.tabList) === null || _a === void 0 ? void 0 : _a.find(function (item) { return (item === null || item === void 0 ? void 0 : item.title.toLowerCase()) === (tab === null || tab === void 0 ? void 0 : tab.toLowerCase()); });
    };
    var handleCheckIfSearchOrFilterApplied = function (object) {
        var allFilterSearchKeys = [
            "amcName",
            "benchmark",
            "expenseRatio",
            "fundSize",
            "rating",
            "riskValue",
            "schPlan",
            "schType",
            "schemeCode",
            "searchText",
            "subCatCode",
            "year1",
            "year3",
            "year5",
        ];
        return allFilterSearchKeys.some(function (key) {
            if (key === "subCatCode" &&
                Object.prototype.hasOwnProperty.call(object, key)) {
                if (object[key].includes("11") &&
                    object[key].length === 1) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return Object.prototype.hasOwnProperty.call(object, key);
            }
        });
    };
    // *******************************************
    // *           MISCELLANEOUS Functions       *
    // *******************************************
    var onFilterSelectionCallback = function (data, isDirectApi) {
        if (isDirectApi === void 0) { isDirectApi = false; }
        setLocalMutualFundFilterSortValues(data);
        if (isDirectApi) {
            handleApplyFilter(data);
        }
    };
    var resetFilterSortValuesStatesToInitial = function (data) {
        if (data === void 0) { data = initialMFFilters; }
        handleUpdateMasterSortFilterValuesState(JSON.parse(JSON.stringify(data)));
        setLocalMutualFundFilterSortValues(JSON.parse(JSON.stringify(data)));
        handleUpdateSelectedFiltersState({});
    };
    var setTabValue = function (key) {
        props.setSelected && props.setSelected(key);
        setTab(key);
    };
    var getSummaryRequest = function () {
        var currentActiveTab = handleFindCurrentActiveTabFromList();
        var request = __assign(__assign({}, JSON.parse(JSON.stringify(initialMFFilters))), { categoryCode: [props.categoryCode], pageNo: 0 });
        if (request.hasOwnProperty("isNew")) {
            delete request.isNew;
        }
        if (request.hasOwnProperty("isFeatured")) {
            delete request.isFeatured;
        }
        switch (tab) {
            case "all funds":
                request = __assign(__assign({}, request), { catCode: [] });
                break;
            case "featured funds":
            case "focused funds":
                {
                    request = __assign(__assign({}, request), { catCode: [], isFeatured: "t" });
                }
                break;
            case "tax savings":
                {
                    request = __assign(__assign({}, request), { catCode: [], subCatCode: ["11"] });
                }
                break;
            case "newly added":
                {
                    request = __assign(__assign({}, request), { catCode: [], isNew: "t" });
                }
                break;
            default: {
                request = __assign(__assign({}, request), (!!currentActiveTab &&
                    (currentActiveTab === null || currentActiveTab === void 0 ? void 0 : currentActiveTab.eventCode) !== "0" && {
                    catCode: [currentActiveTab.eventCode],
                }));
            }
        }
        return request;
    };
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    React.useEffect(function () {
        onFilterSelectionCallback(__assign(__assign({}, localMutualFundFilterSortValues), { pageNo: page }));
        handleUpdateMasterSortFilterValuesState(__assign(__assign({}, masterMutualFundFilterSortValues), { pageNo: page }));
    }, [page]);
    React.useEffect(function () {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.tabList) && (props === null || props === void 0 ? void 0 : props.tabList[1])) {
            setTab((_a = props === null || props === void 0 ? void 0 : props.tabList[1]) === null || _a === void 0 ? void 0 : _a.eventKey);
        }
    }, [props === null || props === void 0 ? void 0 : props.tabList]);
    React.useEffect(function () {
        prevValuesRef.current = localMutualFundFilterSortValues;
    }, [localMutualFundFilterSortValues]);
    React.useEffect(function () {
        if (tab) {
            if (MutualFundsSchemesConfig[tab]) {
                setConfigRequestPayload(__assign(__assign({}, MutualFundsSchemesConfig[tab]), { pageNo: 0 }));
            }
            else {
                updateRequestPayload(requestPayloadState);
            }
            setPage(0);
            var summaryRequest = getSummaryRequest();
            handleUpdateMasterSortFilterValuesState(summaryRequest);
            setLocalMutualFundFilterSortValues(summaryRequest);
            getMutualFundsFilter(summaryRequest);
            getMutualFundsSchems(summaryRequest);
        }
    }, [tab]);
    useEffect(function () {
        // this block is usefull while coming back from Peer comparsion
        if (window.location.href.includes("pc=true")) {
            var paramsDataFromPC = localStorage.getItem("paramsData");
            setConfigRequestPayload(JSON.parse(paramsDataFromPC));
            getMutualFundsSchems(JSON.parse(paramsDataFromPC));
            window.history.replaceState(null, null, window.location.pathname);
            localStorage.removeItem("paramsData");
        }
        getBookMark();
        // getMutualFundsFilter({
        //   ...JSON.parse(JSON.stringify(initialMFFilters)),
        //   categoryCode: [props.categoryCode],
        //   pageNo: 0,
        // });
        return function () {
            di.mutualFunds.clearMutualFundReduxData();
        };
    }, []);
    React.useEffect(function () {
        if (MutualFundsSchemesConfig[subSection]) {
            setConfigRequestPayload(__assign(__assign({}, MutualFundsSchemesConfig[subSection]), { pageNo: 0 }));
            updateRequestPayload(__assign(__assign({}, MutualFundsSchemesConfig[subSection]), { pageNo: 0 }));
        }
        else if (paramsData && paramsData.isExplore) {
            setConfigRequestPayload(__assign(__assign({}, paramsData), { pageNo: 0 }));
        }
    }, [subSection]);
    React.useEffect(function () {
        if (searchSortedDataData && searchSortedDataData.length > 0) {
            setTableData(searchSortedDataData);
        }
        else if ((mutualFundsSchemeList === null || mutualFundsSchemeList === void 0 ? void 0 : mutualFundsSchemeList.length) > 0) {
            setTableData(mutualFundsSchemeList);
        }
    }, [mutualFundsSchemeList, searchSortedDataData]);
    var TabContent = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null,
                props.viewAll && (React.createElement(TopFundsViewAllFunctionality, { mutualFundsSchemeList: tableData, configRequestPayload: configRequestPayload, requestPayload: requestPayload, getMutualFundsSchems: getMutualFundsSchems, filtersDisplayData: mutualFundDisplayFilters, mutualFundFilterSortValues: localMutualFundFilterSortValues, mutualFundFilterSortValuesApplied: masterMutualFundFilterSortValues, onFilterSelectionCallback: onFilterSelectionCallback, handleApplyFilterCallback: handleApplyFilter, handleCancelApplyingFiltersCallback: handleCancelApplyingFilter, handleClearAllFiltersCallback: handleClearAllFilters, setIsShowMainFilterSortPopup: setIsShowMainFilterSortPopup, isShowMainFilterSortPopup: isShowMainFilterSortPopup, selectedFiltersData: selectedFiltersData, handleUpdateSelectedFiltersState: handleUpdateSelectedFiltersState, isShowFilterLoader: isShowFilterLoader, filterFieldsErrors: filterFieldsErrors, setFilterFieldsErrors: setFilterFieldsErrors, currentActiveMutualFundCategory: tab })),
                errorData && errorData.isOpen ? (React.createElement("div", { className: " top-funds-error custom-error-state" },
                    React.createElement(ErrorNotification, { error: errorData === null || errorData === void 0 ? void 0 : errorData.error, isOpen: errorData === null || errorData === void 0 ? void 0 : errorData.isOpen, displayType: ErrorDisplayType.INSECTION, image: somethingWentWrong, customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                            React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                            React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return getMutualFundsSchems(requestPayload); } }, "Try Again")) }))) : (React.createElement(React.Fragment, null, messageData && messageData.show ? (React.createElement("div", { className: "custom-error-state" },
                    React.createElement(Errormsg, { image: noResultsFound, msg: messageData.msg || "No Results", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                            React.createElement("p", { className: "DMSanN_14_400" }, "Please search for something else")) }))) : (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
                    React.createElement(TopFundsTableDesk, { mutualFundsSchemeList: tableData, viewAll: props.viewAll, paramsData: paramsData, nextPage: function (page) {
                            setPage(page);
                            getMutualFundsSchems(__assign(__assign({}, requestPayload), { pageNo: page }));
                        }, page: page, loader: mutualFundsLoader, bookMarkData: bookMarkData, savebookMark: savebookMark, deleteBookMark: deleteBookMark, filterDataList: mutualFundDisplayFilters, handleApplyFilterCallback: handleApplyFilter, handleCancelApplyingFiltersCallback: handleCancelApplyingFilter, handleClearSpecificFilter: handleClearSpecificFilter, onFilterSelectionCallback: onFilterSelectionCallback, mutualFundFilterSortValues: localMutualFundFilterSortValues, totalPages: totalPages, selectedFiltersData: selectedFiltersData, handleUpdateSelectedFiltersState: handleUpdateSelectedFiltersState, categoryCode: props.categoryCode, productCode: props.productCode, componentFlow: props === null || props === void 0 ? void 0 : props.componentFlow }))) : (React.createElement(React.Fragment, null,
                    React.createElement(TopFundsTableMobile, { mutualFundsSchemeList: tableData, paramsData: paramsData }))))))))));
    }, [
        mutualFundsLoader,
        errorData,
        messageData,
        bookMarkData,
        localMutualFundFilterSortValues,
        masterMutualFundFilterSortValues,
        isShowMainFilterSortPopup,
        isShowFilterLoader,
        filterFieldsErrors,
    ]);
    return (React.createElement("div", { className: "primary-offerings-tabs-wrapper", id: "primary-offerings-tabs" },
        props.showTabs && ((_d = props.tabList) === null || _d === void 0 ? void 0 : _d.length) > 0 ? (React.createElement(GenericTabs, { loadContentOnlyIfActive: true, defaultActiveKey: tab, activeKey: tab, tabsArray: props.tabList.map(function (tab) {
                return {
                    title: (device === null || device === void 0 ? void 0 : device.isDesktop) ? tab.title : tab.title,
                    eventKey: tab.eventKey,
                    tabContent: TabContent,
                };
            }), externalClassName: "top-funds-tabs DMSanM_14_500", callBackFunction: function (key) { return setTabValue(key); } })) : (React.createElement("div", { className: "top-funds-tabs" }, TabContent)),
        React.createElement(GenericScrollToTopButton, { scrollingElementRef: document.getElementById("primary-offerings-tabs") }),
        React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: showToast, setClose: function () { return setShowToast(false); }, autohide: true, parentClassName: "product-bouquet-toast" })));
};
export default TopPerformingFundsTabs;
